import React from 'react';

const MyComponent = () => {
  return (
    <div>
      <h1>Welcome To Our UrbanDel</h1>
      <p>UrbanDel Will be in your service soon.</p>
    </div>
  );
};

export default MyComponent;
